import React, { useState } from "react";
import "../assets/css/CgtTraining.css";

const sampleTopics = [
  { id: 1, topic: "Savings & Investment" },
  { id: 2, topic: "Loan Counseling" },
  { id: 3, topic: "Insurance" },
  { id: 4, topic: "Retirement Planning" },
  { id: 5, topic: "Wealth Structuring" },
];

export default function Training() {
  const [filters, setFilters] = useState({
    wealthOfficer: "", 
    center: "",
    group: "",
    day: "",
    cgtId: "",
    expectedStartDate: "",
  });

  const [rows, setRows] = useState(
    sampleTopics.map((t) => ({ ...t, checked: false }))
  );
  const [checkAll, setCheckAll] = useState(false);

  function handleFilterChange(e) {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  }

  function toggleRow(id) {
    const updated = rows.map((r) =>
      r.id === id ? { ...r, checked: !r.checked } : r
    );
    setRows(updated);
    setCheckAll(updated.every((r) => r.checked));
  }

  function toggleCheckAll() {
    const newVal = !checkAll;
    setCheckAll(newVal);
    setRows((prev) => prev.map((r) => ({ ...r, checked: newVal })));
  }

  function handleSearch(e) {
    e.preventDefault();
    // For now just console.log filters & selected topics
    const selectedTopics = rows.filter((r) => r.checked).map((r) => r.topic);
    console.log("Search filters:", filters);
    console.log("Selected topics:", selectedTopics);
    // TODO: call API or propagate filters up via props
    alert(
      `Searching...\nFilters: ${JSON.stringify(filters)}\nSelected Topics: ${selectedTopics.join(
        ", "
      )}`
    );
  }

  return (
    <div className="wo-container">
      <form className="wo-form" onSubmit={handleSearch}>
        <div className="wo-grid">
          <label className="wo-field">
            <span className="wo-label">Wealth Officer</span>
            <select
              name="wealthOfficer"
              value={filters.wealthOfficer}
              onChange={handleFilterChange}
            >
              <option value="">Select Name</option>
              <option value="officer-1">Officer 1</option>
              <option value="officer-2">Officer 2</option>
              <option value="officer-3">Officer 3</option>
            </select>
          </label>

          <label className="wo-field">
            <span className="wo-label">Center</span>
            <select
              name="center"
              value={filters.center}
              onChange={handleFilterChange}
            >
              <option value="">Select Center</option>
              <option value="center-1">Center A</option>
              <option value="center-2">Center B</option>
            </select>
          </label>

          <label className="wo-field">
            <span className="wo-label">Group</span>
            <select
              name="group"
              value={filters.group}
              onChange={handleFilterChange}
            >
              <option value="">Select Group</option>
              <option value="group-1">Group 1</option>
              <option value="group-2">Group 2</option>
            </select>
          </label>

          <label className="wo-field">
            <span className="wo-label">Day</span>
            <select name="day" value={filters.day} onChange={handleFilterChange}>
              <option value="">Select Day</option>
              <option value="monday">Monday</option>
              <option value="tuesday">Tuesday</option>
              <option value="wednesday">Wednesday</option>
              <option value="thursday">Thursday</option>
              <option value="friday">Friday</option>
            </select>
          </label>
        </div>

        <div className="wo-grid wo-grid-2">
          <label className="wo-field">
            <span className="wo-label">CGT ID</span>
            <input
              name="cgtId"
              value={filters.cgtId}
              onChange={handleFilterChange}
              placeholder="Enter CGT ID"
            />
          </label>

          <label className="wo-field">
            <span className="wo-label">Expected Start Date</span>
            <input
              type="date"
              name="expectedStartDate"
              value={filters.expectedStartDate}
              onChange={handleFilterChange}
            />
          </label>
        </div>

        <div className="wo-actions">
          <button type="submit" className="wo-btn">
            Search
          </button>
        </div>
      </form>

      <div className="wo-table-wrap">
        <table className="wo-table">
          <thead>
            <tr>
              <th style={{ width: "70px" }}>Sr.No.</th>
              <th style={{ width: "140px" }}>
                <label className="check-all-label">
                  <input
                    type="checkbox"
                    checked={checkAll}
                    onChange={toggleCheckAll}
                  />{" "}
                  Check All
                </label>
              </th>
              <th>Topics</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, idx) => (
              <tr key={r.id}>
                <td>{idx + 1}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={r.checked}
                    onChange={() => toggleRow(r.id)}
                    aria-label={`select ${r.topic}`}
                  />
                </td>
                <td>{r.topic}</td>
              </tr>
            ))}

            {rows.length === 0 && (
              <tr>
                <td colSpan={3} className="wo-no-data">
                  No topics available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
